import { render } from "./DataSourceForm.vue?vue&type=template&id=18fa47ea"
import script from "./DataSourceForm.vue?vue&type=script&lang=js"
export * from "./DataSourceForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__